module.exports = __webpack_public_path__ + "static/img/item-4-2.ddc3ef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/item-4-2.png
// module id = JssY
// module chunks = 2